<template>
    <section class="view survey-individual-response">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text"
                v-html='``' />
        </div>

        <div class="survey-individual-response__bar">
            <div class="survey-individual-response__bar__back">
                <a :href="previous_id ? `/qc-individual-response/${previous_id}` : 'JavaScript:void(0);'" :class="previous_id ? '' : 'survey-individual-response__bar--disabled'">
                    <i class="fa fa-caret-left" />
                    <span>Back</span>
                </a>
            </div>
            <div class="row m-0 formdynamic survey-individual-response__bar__form" :class="'justify-content-center'" style="padding-top:10px;">
                <div v-for="(key, index) in form_format" :key="index" :class="`${key.css_class}`" class="formdynamic__item py-0" :style="`margin-top:20px`">
                    <label v-html="`${key.name} ${key.required ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label" :for="key.name"/>
                    <div class="formdynamic__item__field" :id="key.id">
                        <input
                        :placeholder="key['placeholder'] !== undefined ? key.placeholder : ''"
                        :disabled="key.disabled"
                        :step="key.step"
                        :type="key.type" 
                        :maxlength="key.maxlength"
                        :style="key.disabled ? 'background-color: #f1f1f1;' : ''"
                        :min="key.type === 'date' && min_date !== undefined ? min_date : key.minlength !== undefined ? key.minlength : ''"
                        :max="key.type === 'date' && max_date !== undefined ? max_date : key.maxlength"
                        :required="key.required"
                        v-model="survey_associate_answer[key.model_name]"
                    />
                    </div>
                </div>
            </div>
            <div class="survey-individual-response__bar__next">
            <a :href="next_id ? `/qc-individual-response/${next_id}` : 'JavaScript:void(0);'" :class="next_id ? '' : 'survey-individual-response__bar--disabled'">
                <span>Next</span>
                <i class="fa fa-caret-right" />
            </a>
            </div>
        </div>


        <div class="tab-content" v-show="survey_questions.length" style="margin-top:40px;">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="w-100 table-responsive overflow-y--1" style="min-height:60vh;">
                                    <table class="table">
                                        <thead style="background-color: #f1f1f1;">
                                            <tr>
                                                <th v-for="(item, i) in table_headers" :key="i" scope="col"
                                                    v-html="item.name" />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, i) in survey_questions" :key="i">
                                                <td v-html="i + 1" />
                                                <td v-html="item.question" />
                                                <td>
                                                    <div class="formdynamic__item__field" v-if="item.response_type === 1">
                                                        <select class="input-field custom-select" :required="true" disabled
                                                            :value="getSelectedAnswer(item)" :id="`select_survey${i}`">
                                                            <option value='' v-html="'Select an option'" />
                                                            <option v-for="(value, j) in item.answers_data" :key="j"
                                                                :value="value.id" v-html="value.answer_text" />
                                                        </select>
                                                    </div>
                                                    <div class="d-inline-block" v-else-if="item.response_type === 2">
                                                        <div v-for="(value, j) in boolean_data" :key="j"
                                                            class="form-check custom-control-inline">
                                                            <input class="form-check-input" type="radio" :name="`radio${i}`"
                                                                :id="`radio${i}`" disabled :value="value.id" 
                                                                :checked="getSelectedBoolean(item, value.id)" />
                                                            <label :ref="`radio${i}`" :class="'ml-1 mt-1 form-check-label'"
                                                                v-html="value.name" />
                                                        </div>
                                                    </div>
                                                    <div class="formdynamic__item__field" v-if="item.response_type === 3">
                                                        <textarea placeholder="Write your answer here"
                                                            :id="`textarea_survey${i}`" :value="getCommentField(item)"
                                                            :maxlength="500" :required="true" rows="5" disabled/>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <WaitingModal />

        <SuccessfullModal :message="`Survey completion success`"
            :second_message="`Thanks for completing the survey! Your responses have been recorded.`"
            @ConfirmSuccess="dashboardReturn()" />

    </section>
</template>
  
<script>

import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import SuccessfullModal from '@/components/SuccessfullModal'
import Resources from './resources'
import FormResources from './form_resources'
// import DinamicTable         from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'SurveyTestCompletion',

    props: [
        'for_personnel'
    ],

    components: {
        Breadcrumb,
        WaitingModal,
        SuccessfullModal,
    },

    data() {
        return {
            notyf,
            user: this.get_user(),
            title_page: '',

            rest_api: `surveys/individual_response/${this.$route.params.id}`,
            survey_associate_answer: {},
            table_headers: Resources.table_headers,
            breadcrumb: Resources.breadcrumb,
            form_format: FormResources.form_format_individual_response,
            single_select: false,
            table_selection: [],
            search: '',
            global_index: '',
            single_object: {},
            survey_questions: [],
            survey_responses: [],
            array_options: {},
            select_ids: [],
            boolean_data: [
                {
                    id: true,
                    name: 'Yes',
                },
                {
                    id: false,
                    name: 'No',
                },
            ],
            next_id: '',
            previous_id: ''
        }
    },

    methods:
    {
        fill_data(data) 
        {
            this.survey_associate_answer = data.survey_associate_answer
            this.survey_questions = data.survey_questions
            this.survey_responses = data.survey_associate_responses
            this.next_id = data.next_id
            this.previous_id = data.previous_id

            this.breadcrumb[3].arrow = `<span class='slash'>/</span>`
            this.breadcrumb[3].name = `${data.survey.name} - Responses`
            this.breadcrumb[3].href = `/qc-survey-responses/${data.survey.encrypted_id}`

            this.title_page = `${data.survey.name} - Responses`

            this.breadcrumb.push({
                name:   `${this.survey_associate_answer.name}`,
                href:   '#',
                arrow:  "",
            })
        },

        reloadPage() 
        {
            console.log('reload')
            window.location.reload();
        }

    },

    async mounted() {
        await this.api_request()
    },

    computed:{
        getSelectedAnswer() 
        {
            return (item) => {
                const response = this.survey_responses.find((res) => res.survey_question_id === item.id);
                return response ? response.survey_answer_id : '';
            };
        },

        getSelectedBoolean() 
        {
            return (item, radio) => {
                console.log(radio)
                const response = this.survey_responses.find((res) => res.survey_question_id === item.id);

                if(response.boolean_field && radio)
                {
                    return true
                }

                if(!response.boolean_field && !radio)
                {
                    return true
                }
            };
        },


        getCommentField() 
        {
            return (item) => {
            const response = this.survey_responses.find((res) => res.survey_question_id === item.id);
            return response ? response.comment_field : '';
            };
        },

    }
}

</script>